// extracted by mini-css-extract-plugin
module.exports = {"OutputDisplay":"OutputDisplay__1rJRt"};